// =====================================================================
// patientService (PME Sprint 0 / S49) — chamadas axios pra API de pacientes (EHR).
//
// Endpoints (todos exigem isAuth no backend; multi-tenant por companyId do JWT):
//   GET    /patients?search=&page=&pageSize=   -> { patients, count, page, pageSize }
//   POST   /patients                           -> paciente criado
//   GET    /patients/:id                        -> detalhe
//   PUT    /patients/:id                        -> atualizado
//   DELETE /patients/:id                        -> 204 (soft-delete)
// =====================================================================
import api from "./api";

export const listPatients = async ({ search, page = 1, pageSize = 20 } = {}) => {
  const params = { page, pageSize };
  if (search) params.search = search;
  const { data } = await api.get("/patients", { params });
  return data; // { patients, count, page, pageSize }
};

export const getPatient = async (id) => {
  const { data } = await api.get(`/patients/${id}`);
  return data;
};

export const createPatient = async (payload) => {
  const { data } = await api.post("/patients", payload);
  return data;
};

export const updatePatient = async (id, payload) => {
  const { data } = await api.put(`/patients/${id}`, payload);
  return data;
};

export const deletePatient = async (id) => {
  await api.delete(`/patients/${id}`);
};

// Traduz o erro do backend EHR (AppError -> { error: "ERR_..." }) numa mensagem amigavel.
export const patientErrorMessage = (err) => {
  const code = err && err.response && err.response.data && err.response.data.error;
  const map = {
    ERR_PATIENT_NAME_REQUIRED: "Informe o nome do paciente.",
    ERR_PATIENT_CPF_DUPLICATE: "Já existe um paciente com esse CPF.",
    ERR_PATIENT_NOT_FOUND: "Paciente não encontrado."
  };
  if (code && map[code]) return map[code];
  if (code && typeof code === "string" && !code.startsWith("ERR_")) return code;
  return "Não foi possível concluir a operação. Tente novamente.";
};
